<p>
    <fa-icon
    class="checkOK"
    size="6x"
    [icon]="faCheck"
    ></fa-icon>
  </p>
  <p>
    {{ 'k004252' | translate }}
    <!-- Token: Great! Entered code is correct -->
  </p>
  <button
  mat-raised-button
  mat-dialog-close
  type="button"
  id="btoSMSnext"
  class="buttonPortal lg my-4"
  color="blue"
  (click)="goNextOK($event)"
>
  <span>{{ 'k000226' | translate }}</span>
  <!-- Token: Continuar -->
</button>